import { Component, OnInit, Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CustomHttpService } from '../services/custom-http.service';
import { AuthService } from '../services/accounts/auth.service';

@Component({
  selector: 'app-chat-widget',
  templateUrl: './chat-widget.component.html',
  styleUrls: ['./chat-widget.component.css']
})
export class ChatWidgetComponent implements OnInit {
  isOpen = false;
  token = '';
  conversationId = '';
  userEmail = '';
  user: any =  {};

  constructor(
    private http: HttpClient, 
    private renderer: Renderer2,
    public auth: AuthService,
    private customHttpService: CustomHttpService,
  ) {}

  ngOnInit(): void {
    this.fetchToken()
    this.user = this.auth.user()
    // console.log('user info', this.user)
  }

  fetchToken(){
    this.customHttpService.createToken().subscribe(
      (data: any) => {
        console.log('token response', data)
        this.token = data.token;
        this.conversationId = data.conversationId;
      },
      (error: any) => {
        console.error('Error fetching token:', error);
      },
    )
  }
  openChat() {
    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      // Request Direct Line token from backend
      // const tokenRes: any = await this.http.post('http://localhost:3978/api/directline/token', {}).toPromise();
      // const token = tokenRes?.token;

       console.log('this isOpen', this.isOpen)
      if (this.token) {
        // Dynamically load Web Chat script
        //console.log('this token', this.token)
         console.log('user info', this.user)
        const script = this.renderer.createElement('script');
        script.src = 'https://cdn.botframework.com/botframework-webchat/latest/webchat.js';
        script.onload = () => {
          (window as any).WebChat.renderWebChat({
            directLine: (window as any).WebChat.createDirectLine({ 
              token: this.token,
              domain: 'https://europe.directline.botframework.com/v3/directline'
            }),
            username: this.user?.email, 
            styleOptions: {
              botAvatarInitials: 'BF',
              userAvatarInitials: 'You',
              backgroundColor: '#f4f7f9'
            }
          }, document.getElementById('webchat'));
        };
        document.body.appendChild(script);
      }
    }
  }
}
